function loadVideoPopup(modal) {
    const videoContainer = modal.querySelector('.video-popup-modal__video-container');
    const videoId = videoContainer.dataset.videoId;
    const videoType = videoContainer.dataset.videoType; // Corrected: was videoId

     if (!videoId || !videoType) {
        console.error('Missing video ID or type for modal:', modal.id);
        return;
     }


     let iframe = videoContainer.querySelector('iframe'); // Look inside the specific container
     if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.setAttribute('frameborder', '0');
        iframe.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture');
        iframe.setAttribute('allowfullscreen', '');
        videoContainer.appendChild(iframe);
     }

    let src = '';
    if (videoType === 'youtube') {
      // Ensure autoplay=1 is added correctly
      src = `https://www.youtube.com/embed/${videoId}?autoplay=1&playsinline=1&modestbranding=1&rel=0`;
    } else if (videoType === 'vimeo') {
      src = `https://player.vimeo.com/video/${videoId}?autoplay=1&loop=0&autopause=0`;
    }

     if(src) {
        iframe.src = src;
     } else {
        console.error('Could not determine video source for type:', videoType);
     }
  }

  function pauseVideoPopup(modal) {
     // Find iframe within the specific modal's container
     const iframe = modal.querySelector('.video-popup-modal__video-container iframe');
     if (iframe) {
       iframe.src = ''; // Stop video by removing src
     }
  }


  // --- Modal Handling (Keep as is, relies on custom elements) ---
  if (!customElements.get('video-modal-opener')) {
      customElements.define('video-modal-opener', class VideoModalOpener extends HTMLElement {
          constructor() {
              super();
              const button = this.querySelector('button');
              if (!button) return;
              button.addEventListener('click', (event) => {
                   event.preventDefault(); // Prevent potential form submissions or navigation
                   const modalId = this.dataset.modal;
                   const modal = document.querySelector(modalId);
                   if (modal && typeof modal.show === 'function') { // Ensure modal and show method exist
                     modal.show(button);
                     // Load video *after* modal is shown
                     loadVideoPopup(modal);
                   } else {
                      console.error('Modal not found or show method missing for:', modalId);
                   }
              });
          }
      });
  }

  if (!customElements.get('video-modal-dialog')) {
      customElements.define('video-modal-dialog', class VideoModalDialog extends HTMLElement {
          #opener = null; // Store the element that opened the modal

          constructor() {
              super();
              this.querySelector('.modal__close-button')?.addEventListener('click', () => this.hide());
              this.addEventListener('click', (event) => {
                  // Close if clicking the overlay (the modal-dialog element itself)
                  if (event.target.nodeName === 'MODAL-DIALOG') {
                     this.hide();
                  }
              });
               this.addEventListener('keyup', (event) => {
                  if (event.code.toUpperCase() === 'ESCAPE') this.hide();
              });
          }

          show(opener) {
              this.#opener = opener; // Remember who opened the modal
              this.style.display = "flex";
              document.body.classList.add('overflow-hidden'); // Prevent background scroll
              this.setAttribute('open', '');
              // Trap focus (basic example)
              this.querySelector('button, iframe')?.focus();
          }

          hide() {
              this.style.display = "none";
              this.removeAttribute('open');
              document.body.classList.remove('overflow-hidden');
              pauseVideoPopup(this); // Pause video when modal closes
              // Return focus to the opener element
              this.#opener?.focus();
              this.#opener = null; // Clear the opener
          }
       });
   }
